import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gym-about',
  templateUrl: './gym-about.component.html',
  styleUrls: ['./gym-about.component.scss']
})
export class GymAboutComponent implements OnInit {
  data = {
    smallTitle: 'גששות',
    title: 'השפה של הטבע',
    p0: `
    משחר האנושות יצא האדם לגשש אחר חיות, בין אם על מנת לצוד ובין אם על מנת להיזהר מחיות שעלולות לסכנו ובאופן כללי עקב רצון וצורך להיות מודע וער לסביבתו. עדויות לכך ניתן למצוא בין השאר בציורי עקבות במערות ועל סלעים במקומות שונים בעולם כגון: דרום אפריקה, נמיביה וארה"ב. היכולת לגשש טבועה בנו כבני אדם , היכולת לזהות עקבות וסימנים שונים, להבין את הסיפור שהעקבות מספרות לנו ולגשש אחר בעל החיים עד שמוצאים אותו הינם חלק בלתי נפרד ממהותנו שכן גם בחיי היום יום המודרניים שלנו אנו מגששים ומנתחים סימנים שונים כגון: בעת הנהיגה בכביש בקריאת התמרורים וזיהוי סכנות אפשריות, חיזוי מזג האוויר, קריאת שפת הגוף של אנשים . כל זאת על מנת להתנהל בעולם בצורה בטוחה ,יעילה וזורמת יותר 
    `,
    title2: `?מדוע ללמוד גששות`,
    p2: `קשה להסביר את תחושת הגילוי והסיפוק בקריאה ובהבנה של סיפורים שכאלה בטבע למי שלא
   התנסה בכך, ישנה תחושה של חיבור עז לסובב אותנו ולעצמנו כבני אדם. סיפורי גששות רבים נמצאים
   מסביבנו ,בטבע הסובב אותנו, סיפורים שרק מחכים שמישהו יקרא אותם לפני שימחקו לעד.
   ישנם סיפורים שמזכירים סיפורים אחרים שקראנו בעבר אך אין סיפור אחד שדומה בדיוק לסיפור אחר.
   תמיד נמצא סיפורים חדשים והתרחשויות מעניינות אם רק נהיה סקרנים ופתוחים מספיק.
   לא פעם יצא לי להדריך אנשים באזורים שקרובים לאזור מגוריהם ולאחר הסדנא הם ציינו שלא היה
   להם מושג שיש שפע גדול כל כך של פעילות בעלי חיים באזור אותו הם מבקרים באופן תדיר.
   בנוסף הגששות הינה כלי שימושי ומוכח ברחבי העולם לטובת מטרות שונות כגון:
איסוף נתונים שונים עבור מחקרים אקדמיים בתחומים כגון: זואולוגיה, אקולוגיה ועוד.
שימור סביבה וטבע, בין אם ככלי לניטור בעלי חיים באזור מסוים או לטובת מאבק בציד לא חוקי.
חיפוש ואיתור נעדרים. שימושים ביטחוניים שונים כגון: משטרה וצבא.
תיירות ופנאי , כלי חינוכי.


   `
  };

  constructor() { }

  ngOnInit() { }
}
